"use strict";
/*
 * Created on 11 01 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var UserMessageConverter_1 = require("../../user-messages/conversions/UserMessageConverter");

var ReferencePrice_1 = require("../model/ReferencePrice");

var ReferencePriceConverter_1 = require("./ReferencePriceConverter");
/**
 * @author Jaroslav Sevcik // fixme name of class and file
 */


var ReferencePriceConverterImpl =
/*#__PURE__*/
function (_ReferencePriceConver) {
  _inherits(ReferencePriceConverterImpl, _ReferencePriceConver);

  function ReferencePriceConverterImpl(userMsgsConverter) {
    var _this;

    _classCallCheck(this, ReferencePriceConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReferencePriceConverterImpl).call(this));
    _this.userMsgsConverter = userMsgsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReferencePriceConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ReferencePrice_1.ReferencePrice(!utils_1.Utils.isValueMissing(source.value) ? ReferencePrice_1.ReferencePrice.schema.value.valueOf(conversions.toBigNumber(source.value)) : null, ReferencePrice_1.ReferencePrice.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), ReferencePrice_1.ReferencePrice.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ReferencePrice_1.ReferencePrice.schema.strategyType.valueOfField(source), conversions.asObjectList(source, 'messages', function (value) {
        return _this2.userMsgsConverter.toObject(value, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      return {
        value: source.value !== null ? conversions.fromBigNumber(source.value) : null,
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        productId: conversions.toDocumentReferenceId(source.productId),
        strategyType: source.strategyType,
        messages: source.messages.map(function (msg) {
          return _this3.userMsgsConverter.toDocument(msg, conversions);
        }).toArray()
      };
    }
  }]);

  return ReferencePriceConverterImpl;
}(ReferencePriceConverter_1.ReferencePriceConverter);

ReferencePriceConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserMessageConverter_1.UserMessageConverter])], ReferencePriceConverterImpl);
exports.ReferencePriceConverterImpl = ReferencePriceConverterImpl;